import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import AppleIcon from '@mui/icons-material/Apple';
import HomeIcon from '@mui/icons-material/Home';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

export default function TimsPlace() {
  return (
    <Container maxWidth="lg">
        <Helmet>
            <title>Finding Tim's Place</title>
            <meta name="description" content="Directions and parking information for Tim's place in Austin, TX." />
        </Helmet>
      <Box sx={{ 
        textAlign: 'center', 
        marginTop: '40px',
        marginBottom: '40px'
      }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Finding Tim's Place
        </Typography>
        
        <Box sx={{ marginBottom: '20px' }}>
          <Button
            component={Link}
            to="/"
            startIcon={<HomeIcon />}
            sx={{ marginBottom: '16px' }}
          >
            Home
          </Button>
        </Box>
        
        <Typography variant="body2" color="text.secondary">
          1508 Summer Stone APT #C
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Austin, TX 78704
        </Typography>
        
        <Box sx={{ marginTop: '16px', marginBottom: '20px', display: 'flex', justifyContent: 'center', gap: '16px' }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<GoogleIcon />}
            href="https://maps.app.goo.gl/PTDFrBy1LJzEHT1q6"
            target="_blank"
            rel="noopener noreferrer"
          >
            Map
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AppleIcon />}
            href="https://maps.apple/p/FG5rTaJJcMCf-0"
            target="_blank"
            rel="noopener noreferrer"
          >
            Map
          </Button>
        </Box>
        
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center',
          marginTop: '20px'
        }}>
          <img 
            src="/parking-cropped.png" 
            alt="Parking Information" 
            style={{ 
              maxWidth: '100%',
              height: 'auto',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
            }}
          />
        </Box>
      </Box>
    </Container>
  );
}